<template>
  <div class="details">
    <el-container>
      <el-main ref="main">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="上传人：">
                    <el-input v-model="dataForm.projectDeptName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发布日期：">
                    <el-input v-model="dataForm.projectName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="其他信息" name="Tab2" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="标题：">
                    <el-input v-model="dataForm.projectDeptName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发文字号：">
                    <el-input v-model="dataForm.projectName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发文日期：">
                    <el-input v-model="dataForm.projectDeptName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发文部门：">
                    <el-input v-model="dataForm.projectName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="120px" label="内容：">
                    <div class="fileList">
                      <div class="fileItem">
                        <div class="fileName">文档.docx</div>
                        <el-button type="primary">预览</el-button>
                        <el-button type="primary">下载</el-button>
                      </div>
                      <div class="fileItem">
                        <div class="fileName">文档.docx</div>
                        <el-button type="primary">预览</el-button>
                        <el-button type="primary">下载</el-button>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="reset()">关闭</el-button>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: "details",
    data(){
      return {
        activeName: 'Tab1',
        dataForm: {

        }
      }
    },
    methods:{
      reset(){
        this.bus.$emit("tabClose", "lookUpDetails");
        this.bus.$emit("navMenuChange", {
          routeId: "lookUpIndex"
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .details {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .container{
      width: 900px;
    }
  }
  /deep/.el-container .el-main{
    height: 100%;
  }
  /deep/.el-textarea{
    width: 600px;
  }
  /deep/.el-tabs__header{
    padding-right: 0 !important;
    .el-tabs__nav-wrap{
      padding-left: 30px;
    }
  }
  /deep/.el-input.is-disabled .el-input__inner{
    background-color: #fff !important;
    color: #606266 !important;
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
  .fileList{
    .fileItem{
      display: flex;
      align-content: center;
      margin-bottom: 10px;
      .fileName{
        margin-right: 30px;
      }
    }
  }
</style>